module.exports = __webpack_public_path__ + "images/category_lp/alcohol/store_images/3_c12bbfcc3e173519635b5643a23088c2.png";